export const CONFIRMATION_DIALOG__DELETE_SEO_TRANSLATIONS = 'CONFIRMATION_DIALOG__DELETE_SEO_TRANSLATIONS';
export const CONFIRMATION_DIALOG__DELETE_SEO_TRANSLATIONS_BY_LANG = 'CONFIRMATION_DIALOG__DELETE_SEO_TRANSLATIONS_BY_LANG';
export const CONFIRMATION_DIALOG__DELETE_CUSTOM_TAG = 'CONFIRMATION_DIALOG__DELETE_CUSTOM_TAG';
